var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIceLabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 33,
    viewBox: "0 0 77 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 31,
    rx: 8,
    fill: "#74CEC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7624 7.60132L24.827 13.2758L19.8777 15.6517L19.8167 10.2939L24.7624 7.60132Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.724 16.543L24.8244 19.3454L19.922 16.5385L24.8219 13.9647L29.724 16.543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0505 16.543L14.151 19.3454L9.24854 16.5385L14.1484 13.9647L19.0505 16.543Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0959 7.57806L19.1813 10.0967L19.0513 15.5852L14.2498 13.2072L14.0959 7.57806Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9009 25.4219L19.8156 22.9033L19.9456 17.4147L24.7471 19.7928L24.9009 25.4219Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2715 25.473L14.2069 19.7985L19.1563 17.4225L19.2173 22.7803L14.2715 25.473Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.352 11.242V21H48.078V11.242H49.352ZM51.0473 17.15C51.0473 16.3567 51.206 15.666 51.5233 15.078C51.8406 14.4807 52.2793 14.0187 52.8393 13.692C53.4086 13.3653 54.0573 13.202 54.7853 13.202C55.728 13.202 56.5026 13.4307 57.1093 13.888C57.7253 14.3453 58.1313 14.98 58.3273 15.792H56.9553C56.8246 15.3253 56.568 14.9567 56.1853 14.686C55.812 14.4153 55.3453 14.28 54.7853 14.28C54.0573 14.28 53.4693 14.532 53.0213 15.036C52.5733 15.5307 52.3493 16.2353 52.3493 17.15C52.3493 18.074 52.5733 18.788 53.0213 19.292C53.4693 19.796 54.0573 20.048 54.7853 20.048C55.3453 20.048 55.812 19.9173 56.1853 19.656C56.5586 19.3947 56.8153 19.0213 56.9553 18.536H58.3273C58.122 19.32 57.7113 19.95 57.0953 20.426C56.4793 20.8927 55.7093 21.126 54.7853 21.126C54.0573 21.126 53.4086 20.9627 52.8393 20.636C52.2793 20.3093 51.8406 19.8473 51.5233 19.25C51.206 18.6527 51.0473 17.9527 51.0473 17.15ZM67.0272 16.87C67.0272 17.1127 67.0132 17.3693 66.9852 17.64H60.8532C60.8999 18.396 61.1566 18.9887 61.6232 19.418C62.0992 19.838 62.6732 20.048 63.3452 20.048C63.8959 20.048 64.3532 19.922 64.7172 19.67C65.0906 19.4087 65.3519 19.0633 65.5012 18.634H66.8732C66.6679 19.3713 66.2572 19.9733 65.6412 20.44C65.0252 20.8973 64.2599 21.126 63.3452 21.126C62.6172 21.126 61.9639 20.9627 61.3852 20.636C60.8159 20.3093 60.3679 19.8473 60.0412 19.25C59.7146 18.6433 59.5512 17.9433 59.5512 17.15C59.5512 16.3567 59.7099 15.6613 60.0272 15.064C60.3446 14.4667 60.7879 14.0093 61.3572 13.692C61.9359 13.3653 62.5986 13.202 63.3452 13.202C64.0732 13.202 64.7172 13.3607 65.2772 13.678C65.8372 13.9953 66.2666 14.434 66.5652 14.994C66.8732 15.5447 67.0272 16.17 67.0272 16.87ZM65.7112 16.604C65.7112 16.1187 65.6039 15.7033 65.3892 15.358C65.1746 15.0033 64.8806 14.7373 64.5072 14.56C64.1432 14.3733 63.7372 14.28 63.2892 14.28C62.6452 14.28 62.0946 14.4853 61.6372 14.896C61.1892 15.3067 60.9326 15.876 60.8672 16.604H65.7112Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 76,
    height: 32,
    rx: 8.5,
    stroke: "white",
    strokeOpacity: 0.47,
    strokeDasharray: "2 2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceLabel);
export default __webpack_public_path__ + "static/media/iceLabel.6b9ea4f05edbe41333556b001bcb9b8f.svg";
export { ForwardRef as ReactComponent };